import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import axios from '../axiosConfig';  
import { toast } from 'react-hot-toast';


const Logout = () => {
  const [loading, setLoading] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    // Check if the user is already logged in
    const token = localStorage.getItem('auth_token'); // Remplacez par la clé appropriée
    if (token) {
      setIsLoggedIn(true); // Update the state if the user is logged in
    }
  }, []);

  const handleLogout = async () => {
    setLoading(true); // Release the loading state during the request

    try {
      // Perform the POST request for logout
      const response = await axios.post('/api/logout');
      setIsLoggedIn(false);
      toast.success('You\'ve successfully logged off!');
      
    } catch (error) {
      console.error('Disconnection error:', error);
      toast.error('An error has occurred during disconnection.');
    } finally {
      setLoading(false);  // Update the loading state after the request
    }
  };
  
  if (!isLoggedIn) {
    return null;
  }

  return (
    <div className="text-center mt-4 mb-3">
      <Button
        variant="danger"
        onClick={handleLogout}
        disabled={loading} // Disable the button during loading
      >
        {loading ? 'Logout in progress ...' : 'Logout'}
      </Button>
    </div>
  );
};

export default Logout;